import * as actionTypes from "./actionTypes";
import { licenseServices } from "../services/license.admin.service";

export const resetLicense = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_LICENSE,
  });
};
export const getLicenses = (error) => async (dispatch) => {
  try {
    const res = await licenseServices.getLicenses("");
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_LICENSES,
        payload: res.data.returnObject,
        // payload: licenses,
      });
    } else {
      dispatch({
        type: actionTypes.GET_LICENSES,
        payload: null,
      });

      error(res.data.message);
    }
  } catch (e) {
    console.log(e);
    error(e.message);
  }
};

export const searchLicenses = (search, error) => async (dispatch) => {
  try {
    const res = await licenseServices.getLicenses(search);

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.SEARCH_LICENSES,
        payload: res.data.returnObject,
      });
    } else {
      dispatch({
        type: actionTypes.SEARCH_LICENSES,
        payload: null,
      });

      error(res.data.message);
    }
  } catch (e) {
    console.log(e);
    error(e.message);
  }
};

export const getBanks =
  (search = "", countryId, error) =>
  async (dispatch) => {
    try {
      const res = await licenseServices.getBanks(search, countryId);

      if (res.data.responseCode === "SUCCESS") {
        dispatch({
          type: actionTypes.GET_BANKS,
          payload: res.data.returnObject,
          // payload: banks,
        });
      } else {
        dispatch({
          type: actionTypes.GET_BANKS,
          payload: null,
        });

        error(res.data.message);
      }
    } catch (e) {
      console.log(e);
      error(e.message);
    }
  };

export const updateLicense = (data, success, error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SET_PROCESSING });

    const res = await licenseServices.updateLicense(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);

      dispatch({
        type: actionTypes.UPDATE_LICENSE,
        payload: res.data.returnObject,
      });
    } else {
      error(res.data.message);

      dispatch({
        type: actionTypes.STOP_PROCESSING,
      });
    }
  } catch (e) {
    console.log(e);
    error(e.message);
    dispatch({ type: actionTypes.STOP_PROCESSING });
  }
};

export const generateLicense =
  (data, success, error) => async (dispatch, getState) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING });

      const res = await licenseServices.generateLicense(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);

        dispatch({
          type: actionTypes.GENERATE_LICENSE,
          payload: res.data.returnObject,
        });
      } else {
        const { adminLicense } = getState();
        error(res.data.message);
        dispatch({
          type: actionTypes.SET_CURRENT_LICENSE,
          payload: adminLicense.licenses?.length
            ? adminLicense.licenses[0].key
            : null,
        });

        dispatch({ type: actionTypes.STOP_PROCESSING });
      }
    } catch (e) {
      console.log(e);
      error(e.message);
      dispatch({ type: actionTypes.STOP_PROCESSING });
    }
  };

export const getModules = (error) => async (dispatch) => {
  try {
    const res = await licenseServices.getModules();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_MODULES,
        payload: res.data.returnObject,
        // payload: modules,
      });
    } else {
      dispatch({
        type: actionTypes.GET_MODULES,
        payload: res.data.returnObject,
        // payload: modules,
      });

      error(res.data.message);
    }
  } catch (e) {
    console.log(e);
    error(e.message);
  }
};

export const getCountries = (error) => async (dispatch) => {
  try {
    const res = await licenseServices.getCountries();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_COUNTRIES,
        payload: res.data.returnObject,
        // payload: COUNTRIES,
      });
    } else {
      dispatch({
        type: actionTypes.GET_COUNTRIES,
        payload: res.data.returnObject,
        // payload: modules,
      });

      error(res.data.message);
    }
  } catch (e) {
    console.log(e);
    error(e.message);
  }
};

//dummy data
// const licenses = [
//   {
//     uniqueId: "1",
//     bankId: 1,
//     bankName: "NBE",
//     bankShortName: "NBE",
//     bankBic: "NBE",
//     licenseName: "name 1",
//     messages: 5,
//     allowedUsers: 7,
//     expiryDate: "2023-01-01",
//     creationDate: "2022-01-01",
//     modules: [
//       {
//         module: {
//           id: 1,
//           name: "Search & Archival",
//           description: "This is the description",
//           isLocked: true,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 2,
//           name: "Alerts & Notifications",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 3,
//           name: "Matching",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 4,
//           name: "SWIFT GPI/ or UC",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 5,
//           name: "Correspondent Fees Calculation",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 6,
//           name: "BUNA",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 7,
//           name: "Posting",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//       {
//         module: {
//           id: 8,
//           name: "Regulatory Reports",
//           description: "This is the description",
//           isLocked: false,
//         },
//         isAllowed: true,
//       },
//     ],
//     key: "/aV3lkhqVFalVPViAbwT+UkLRXQ9HCJGpiZJh0dNAYyhGcb52U2VUbc0fQclHaxke8wML3iAYfZ6/clEGVUd08/cfg8frk8+cM2Nrsdq3JdNEtx7y8+cQq7QtKGixw2mFxe68o+zmiwFpafBt56esNfvEC9AqfGOx1dbKZ2rmRFAq+0eZHoLzy1ZAb+ZHWYsKZcL27txoL+Ehrchc2S8gnSsqP/Vovw7Sc5qd0sIFGd22xwjcN905EQI0N3+Kxv+",
//     keySimplified: "L2FWM-2XRAH-FWRMF-SVLBW-AUFID",
//     status: "ACTIVE",
//   },
//   // {
//   //   uniqueId: "2",
//   //   licenseName: "name 2",
//   //   bankName: "BANK MISR",
//   //   bankShortName: "BANKMISR",
//   //   bankBic: "BANKMISR140",
//   //   messages: 5,
//   //   allowedUsers: 7,
//   //   expiryDate: "2023-01-01",
//   //   creationDate: "2022-01-01",
//   //   modules: [
//   //     {
//   //       id: 1,
//   //       name: "Search & Archival",
//   //       description: "This is the description",
//   //       isLocked: true,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 2,
//   //       name: "Alerts & Notifications",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 3,
//   //       name: "Matching",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 4,
//   //       name: "SWIFT GPI/ or UC",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 5,
//   //       name: "Correspondent Fees Calculation",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 6,
//   //       name: "BUNA",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 7,
//   //       name: "Posting",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //     {
//   //       id: 8,
//   //       name: "Regulatory Reports",
//   //       description: "This is the description",
//   //       isLocked: false,
//   //       isAllowed: true,
//   //     },
//   //   ],
//   //   key: "/aV3lkhqVFalVPViAbwT+UkLRXQ9HCJGpiZJh0dNAYyhGcb52U2VUbc0fQclHaxke8wML3iAYfZ6/clEGVUd08/cfg8frk8+cM2Nrsdq3JdNEtx7y8+cQq7QtKGixw2mFxe68o+zmiwFpafBt56esNfvEC9AqfGOx1dbKZ2rmRFAq+0eZHoLzy1ZAb+ZHWYsKZcL27txoL+Ehrchc2S8gnSsqP/Vovw7Sc5qd0sIFGd22xwjcN905EQI0N3+Kxv+",
//   //   keySimplified: "L2FWM-2XRAH-FWRMF-SVLBW-AUFID",
//   //   status: "ACTIVE",
//   // },
// ];

// const modules = [
//   {
//     id: 1,
//     name: "Search & Archival",
//     description: "This is the description",
//     isLocked: true,
//   },
//   {
//     id: 2,
//     name: "Alerts & Notifications",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 3,
//     name: "Matching",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 4,
//     name: "SWIFT GPI/ or UC",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 5,
//     name: "Correspondent Fees Calculation",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 6,
//     name: "BUNA",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 7,
//     name: "Posting",
//     description: "This is the description",
//     isLocked: false,
//   },
//   {
//     id: 8,
//     name: "Regulatory Reports",
//     description: "This is the description",
//     isLocked: false,
//   },
// ];

// const banks = [
//   {
//     id: "NBE",
//     name: "NBE",
//     shortName: "NBE",
//     bics: [{ id: "NBE", value: "NBE" }],
//   },
//   {
//     id: "BANKMISR",
//     name: "BANKMISR",
//     shortName: "BANKMISR",
//     bics: [{ id: "BANKMISR", value: "BANKMISR" }],
//   },
//   {
//     id: "CIB",
//     name: "CIB",
//     shortName: "CIB",
//     bics: [{ id: "CIB", value: "CIB" }],
//   },
// ];
